
import iconBack from "../../../Icons/icons-white/back.png";
import iconClose from "../../../Icons/icons-white/exit-2px.png";
// import backPhoto from "../../images/backphoto 1.png";
import backPhoto from "../../images/backgrounds/mai-logo-blured.avif";
// import backPhoto from "../../images/backgrounds/20 x 20.avif";
// import backPhoto from "../../images/backgrounds/500 x 500.avif";
import iconWhiteLocationRadius from "../../../Icons/icons-white/location-radius.png";
import iconBlackLocationRadius from "../../../Icons/icons-black/location-radius.png";

import iconBlackSearch from "../../../Icons/icons-black/search.png";
import iconListings from "../../../Icons/icons-black/listings.png";
import iconBusiness from "../../../Icons/icons-black/business.png";
import iconSeller from "../../../Icons/icons-black/seller.png";
// import iconToTop from "../../../Icons/icons-white/to top.png";
import iconAdd from "../../../Icons/icons-white/add.png";
import icon30Sec from "../../../Icons/icons-black/30 sec icon.png";

// <div id="homeScreenDisplayInitialScreenScrollButtonScrollTop" class="initScreenButtonScrollTopCon1 initScreenButtonScrollTopCon1Translate100">
//   <img height="20px" src="${iconToTop}" alt="" />
// </div>


class GenarateHtml {

  _topToolsSetter() {
    return `




      <img class="maiHomeScreenTipsCon1BackPhoto" src="${backPhoto}"/>
      <div id="homeScreenDisplayAll" class="homeScreenDisplayMainScreens" style="display: none">
        <div id="MainHomeContainerForAllItemsDisplay" class="MainAppConWithNavigationContentConForListings" style="display: none"></div>
        <div id="NVHomeMainContainerListings" class="MainAppConWithNavigationContentConForListings" style="display: flex"></div>
        <div id="NVHomeMainContainerBusinesses" class="MainAppConWithNavigationContentConForListings" style="display: none"></div>
        <div id="NVHomeMainContainerSellers" class="MainAppConWithNavigationContentConForListings" style="display: none"></div>

        <div id="homeScreenDisplayAllButtonBack" class="homeHeaderSearchCon10A1 topRightExitButtonOnFullScreenWindow" style="display: flex">
            <img height="30px" src="${iconBack}"/>
        </div>


        <div id="homeHeaderSearchCon1" class="homeHeaderSearchCon1">
          <div class="homeHeaderSearchCon3">

            <div id="nvHeaderCon2BigAddContainerA" class="nvHeaderCon2BigAddA">
              <div id="nvHeaderCon2BigAddContainer" class="nvHeaderCon2BigAdd"></div>
            </div>

            <div id="homeHeaderSearchCon9" class="homeHeaderSearchCon9">

              <div id="homeHeaderSearchCon10A" class="homeHeaderSearchCon10A homeHeaderSearchCon10APaddingLeft">

                <div class="homeHeaderSearchCon10A2">
                  <label id="homeHeaderSearchCon10" class="homeHeaderSearchCon10">
                    <img id="SearchStartUpComponentSearchInputIcon" height="20px" src="${iconBlackSearch}" alt="" />
                    <input
                      id="SearchStartUpComponentSearchInput"
                      class="SearchStartUpComponentCon5Input"
                      type="text"
                      placeholder="Buscar en Mercado MAI"
                      enterkeyhint="search" 
                    />
                  </label>
                </div>
                <div data-close="search" id="homeScreenDisplayAllButtonCloseSearch" class="homeHeaderSearchCon10A1 topRightExitButtonOnFullScreenWindow" style="display: none">
                    <img height="16px" src="${iconClose}"/>
                </div>
              </div>


              <div id="homeHeaderSearchCatCon" class="homeHeaderSearchCon11">
                <div class="homeHeaderSearchCon12">

                  <div data-category="listings" class="headerCatSelectorOnClick homeHeaderCategorySelectCon1 homeHeaderCategorySelectCon1ACT">
                    <div class="homeHeaderCategorySelectCon2 homeHeaderCategorySelectCon2Act">
                      <div class="homeHeaderSearchText1 homeHeaderSearchText1ACT">Listados</div>
                      <div id="homeHeaderSearchText1BListings" class="homeHeaderSearchText1B homeHeaderSearchText1BACT"></div>
                    </div>
                  </div> 

                  <div data-category="businesses" class="headerCatSelectorOnClick homeHeaderCategorySelectCon1">
                    <div class="homeHeaderCategorySelectCon2">
                      <div class="homeHeaderSearchText1">Empresas</div>
                      <div id="homeHeaderSearchText1BBusinesses" class="homeHeaderSearchText1B"></div>
                    </div>
                  </div> 

                  <div data-category="indsellers" class="headerCatSelectorOnClick homeHeaderCategorySelectCon1">
                    <div class="homeHeaderCategorySelectCon2">
                      <div class="homeHeaderSearchText1">Vendedores</div>
                      <div id="homeHeaderSearchText1BSellers" class="homeHeaderSearchText1B"></div>
                    </div>
                  </div> 

                </div>
              </div>

              <div id="locationFilterParentCon" class="locationFilterCon1">
                <div id="locationFilterAdjCon" class="locationFilterCon6" style="display: none">
                  <div class="locationFilterCon7">
                    <div class="locationFilterCon8">
                      <div class="locationFilterText3">Encontrar cerca de:</div>
                    </div>
                    <div class="locationFilterCon9">
                      <div id="locationFilterTagButtonOpenLocation" class="locationFilterCon10">
                        <img height="16px" src="${iconBlackLocationRadius}"/>
                        <div id="locationFilterSelectedLocationTag" class="locationFilterText4">Favor selecciona una ubicación primero</div>
                      </div>
                      <div id="locationFilterButtonOpenLocation" class="locationFilterCon11">
                        <div class="locationFilterText5">Cambiar</div>
                      </div>
                    </div>
                  </div>
                  <div class="locationFilterCon12">
                    <div class="locationFilterCon13">
                      <div class="locationFilterCon14">
                        <div class="locationFilterCon15">
                          <div class="locationFilterText6">Todo dentro de</div>
                        </div>

                        <div class="locationFilterKmCon1">
                          <div class="locationFilterKmCon3">
                            <div class="locationFilterKmCon4"></div>
                            <div id="locationFilterKmCon5" class="locationFilterKmCon5">
                              <div class="locationFilterKmCon7" data-km="10">
                                <div class="locationFilterKmText1">10 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="20">
                                <div class="locationFilterKmText1">20 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="50">
                                <div class="locationFilterKmText1">50 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="100">
                                <div class="locationFilterKmText1">100 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="200">
                                <div class="locationFilterKmText1">200 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="500">
                                <div class="locationFilterKmText1">500 Km</div>
                              </div>
                            </div>
                            <div class="locationFilterKmCon6"></div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="locationFilterCon16">
                    <div id="locationFilterButtonCloseFilter" class="locationFilterCon17 topRightExitButtonOnFullScreenWindow">
                      <div class="locationFilterText7">Cerrar filtro</div>
                    </div>
                    <div id="locationFilterButtonAplyFilter" class="locationFilterCon18">
                      <div class="locationFilterText8">Filtrar listados</div>
                    </div>
                  </div>
                </div>


                <div id="locationFilterOpenerCon" class="locationFilterCon2" style="display: flex">
                  <div class="locationFilterCon3">
                    <div class="locationFilterCon4">
                      <div class="locationFilterText1">Encuentra lo que está cerca de tí</div>
                    </div>
                    <div class="locationFilterCon5">
                      <img height="16px" src="${iconWhiteLocationRadius}"/>
                      <div class="locationFilterText2">Descubrir</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div id="NVHeaderConSearchConPullDownCon1" class="NVHeaderConSearchConPullDownCon1">
            <div id="NVHeaderConSearchCon2B2" class="NVHeaderConSearchCon2B"></div>
          </div>

        </div>
      </div>





      <div id="homeScreenDisplayInitialScreen" class="homeScreenDisplayMainScreens" style="display: flex">
        <div id="homeScreenDisplayInitialScreenScroll" class="initScreenCon1">
        
          <div class="initScreenCon2">
           
            <div id="initScreenCon3" class="initScreenCon3">
              <div id="initScreenOpenSearch" class="initScreenCon4">
                <img height="20px" src="${iconBlackSearch}" alt="" />
                <div class="initScreenText1">Buscar en Mercado MAI</div>
              </div>
            </div>





            <div id="" class="maiHomeScreenTipsCon1" style="display: flex">
              <div class="maiHomeScreenTipsCon2 maiHomeScreenTipsCon2NEW">
                <div class="maiHomeScreenTipsCon3">
                  <div class="maiHomeScreenTipsCon4 maiHomeScreenTipsCon4NEW">
                    <div class="mercadoMaiTips mercadoMaiTipsNEW">Descubre lo nuevo</div>
                  </div>
                </div>

                <div class="homeScreenLocationFilterCtaCon1">

                  <div id="homeScreenLocationFilterCtaCon2" class="homeScreenLocationFilterCtaCon2">
                    <div class="homeScreenLocationFilterCtaCon3">
                      <div class="homeScreenLocationFilterCtaCon7">
                        <div class="homeScreenLocationFilterCtaText2">Ya puedes filtrar por ubicación</div>
                        <div class="homeScreenLocationFilterCtaCon8">
                          <div class="homeScreenLocationFilterCtaText3">'Cerca de mi'</div>
                          <img height="16px" src="${iconBlackLocationRadius}"/>
                        </div>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon6">
                        <img class="homeScreenLocationFilterCtaCon6Img" src="https://storage.googleapis.com/mqmexico-7c834.firebasestorage.app/mercado_mai_tips/thumbnails/variants/res_500/87ae8cdc-82ec-46f1-a6e9-09432785719c.avif"/>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon5">
                        <img height="16px" src="${iconWhiteLocationRadius}"/>
                        <div class="homeScreenLocationFilterCtaText4">Encontrar listados cercanos ahora</div>
                      </div>
                      <div class="homeScreenLocationFilterCtaCon4">
                        <div class="homeScreenLocationFilterCtaText1">NUEVO</div>
                      </div>
                    </div>
                  </div>

                  <div id="homeScreenUploadCtaCon2" class="homeScreenLocationFilterCtaCon2">
                    <div class="homeScreenLocationFilterCtaCon3">
                      <div class="homeScreenLocationFilterCtaCon7">
                        <div class="homeScreenLocationFilterCtaText2 homeScreenLocationFilterCtaText2SubUpload">Publicar mas rápido</div>
                        <div class="homeScreenLocationFilterCtaCon8">
                          <div class="homeScreenLocationFilterCtaText3">30 seg.</div>
                          <img height="16px" src="${icon30Sec}"/>
                        </div>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon6">
                        <img class="homeScreenLocationFilterCtaCon6Img" src="https://storage.googleapis.com/mqmexico-7c834.firebasestorage.app/mercado_mai_tips/thumbnails/variants/res_500/4a178e37-0184-4ec6-a774-ae57ac51cdc3.avif"/>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon5 homeScreenLocationFilterCtaCon5SubUpload">
                        <img height="16px" src="${iconAdd}"/>
                        <div class="homeScreenLocationFilterCtaText4 homeScreenLocationFilterCtaText4SubUpload">Publicar listado</div>
                      </div>
                      <div class="homeScreenLocationFilterCtaCon4">
                        <div class="homeScreenLocationFilterCtaText1">Mejorado</div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>







            <div id="initScreenInsertTopAdds" class="initScreenCon6 initScreenCon6NoAdds">
              <div class=" "></div>
            </div>


            <div id="maiHomeScreenTipsCon5TipsParentCon" class="maiHomeScreenTipsCon1" style="display: none">

              <div class="maiHomeScreenTipsCon2 maiHomeScreenTipsCon2TIPS">
                <div class="maiHomeScreenTipsCon3">
                  <div class="maiHomeScreenTipsCon4 maiHomeScreenTipsCon4TIPS">
                    <div class="mercadoMaiTips mercadoMaiTipsTIPS">Tips</div>
                  </div>
                </div>
                <div id="maiHomeScreenTipsCon5TipsCon" class="maiHomeScreenTipsCon5"></div>
              </div>
            </div>




            
  
          </div>
          <div class="initScreenCon14B">
            <div id="" class="maiHomeScreenTipsCon1B" style="display: flex">
              <div class="maiHomeScreenTipsCon2 maiHomeScreenTipsCon2CAT">
                <div class="maiHomeScreenTipsCon3">
                  <div class="maiHomeScreenTipsCon4 maiHomeScreenTipsCon4CAT">
                    <div class="mercadoMaiTips mercadoMaiTipsCAT">Descubre mas</div>
                  </div>
                </div>

                <div class="initScreenCon11">
                  <div id="initScreenOpenListings" class="initScreenCon12">
                    <div class="initScreenCon13">
                      <img height="29px" src="${iconListings}" alt="" />
                    </div>
                    <div class="initScreenText3">Listados</div>
                  </div>
                  <div id="initScreenOpenBusinesses" class="initScreenCon12">
                    <div class="initScreenCon13">
                      <img height="29px" src="${iconBusiness}" alt="" />
                    </div>
                    <div class="initScreenText3">Empresas</div>
                  </div>
                  <div id="initScreenOpenSellers" class="initScreenCon12">
                    <div class="initScreenCon13">
                      <img height="29px" src="${iconSeller}" alt="" />
                    </div>
                    <div class="initScreenText3">Vendedores</div>
                  </div>
                </div>
              </div>
            </div>

            <div id="initScreenInsertListings" class="initScreenCon14"></div>
          </div>
        </div>
      </div>
    `;
  }

  _initScreenAdd(data) {

    // --- Build gradient string ---
    const gradient = data.gradient;
    let backgroundStyle = '';

    if (gradient?.type === "linear") {
      const stops = gradient.stops
        .map(stop => `${stop.color} ${stop.pos}%`)
        .join(', ');

      backgroundStyle = `linear-gradient(${gradient.angle}deg, ${stops})`;
    }

    // --- Build items HTML dynamically ---
    const itemsHtml = data.items.map(item => `
    <div data-openlink="${item.openLink || data.openLink}" class="initScreenTopAddCon4">
      <img class="initScreenTopAddCon5" src="${item.imageUrl || 'https://placehold.co/90x66'}">
      <div class="initScreenTopAddText2">${item.text}</div>
    </div>
  `).join('');

    return `
    <div data-openlink="${data.openLink}" class="initScreenTopAddCon1" style="background:${backgroundStyle}">
      
      <div class="initScreenTopAddText1" style="color:${data.title.color}">
        ${data.title.text}
      </div>

      <div class="initScreenTopAddCon2">
        <div class="initScreenTopAddCon3">
          ${itemsHtml}
        </div>
      </div>

      <div class="initScreenTopAddCon6">
        <div class="initScreenTopAddText3" style="color:${data.description.color}">
          ${data.description.text}
        </div>
        <div class="initScreenTopAddText4" style="color:${data.ctaText.color}">
          ${data.ctaText.text}
        </div>
      </div>

      <div class="initScreenTopAddCon7">
        <div
          class="initScreenTopAddCon8" 
          style="background:${data.button.buttonColor}"
        >
          <div 
            class="initScreenTopAddText5" 
            style="color:${data.button.textColor}"
          >
            ${data.button.text}
          </div>
        </div>
      </div>

    </div>
  `;
  }

  _addContainerM1(adds) {

    return `
    
      <div class="model1AddCon1">
        <div class="model1AddCon2">
          <div class="model1AddCon3">
            <div class="model1AddText1">Hecha un vistazo</div>
          </div>
          <img class="model1AddButtonClose" height="10px" src="${iconClose}">
        </div>
        <div class="model1AddCon4">${adds}</div>
      </div>

    
    `

  }

}

export default new GenarateHtml();
